import React, { useEffect, useLayoutEffect, useState } from "react";
import airconhistoryService from "../services/airconhistory.service";
import ReactPaginate from "react-paginate";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { format } from "date-fns";
import Loader from "../components/Loader";
import { Link, useNavigate } from "react-router-dom";
import Alertmsg from "../components/Alertmsg";
import clientService from "../services/client.service";
import analyticsService from "../services/analytics.service";
import Jspdfrender from "../components/Jspdfrender";
const Reports = (props) => {
  let navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const [ismessage, setIsmessage] = useState(false);
  const [totalexpanse, setTotalexpanse] = useState(0);

  const [airconhistorys, setAirconhistorys] = useState([]);
  const [clients, setClients] = useState([]);
  const [selectedclient, setSelectedclient] = useState([]);
  const [generatepdf, setGeneratepdf] = useState(false);

  const [result, setResult] = useState([]);
  //smart table data
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [filter, setFilter] = useState("issue");
  const [filterclient, setFilterclient] = useState("");
  const [filteraircon, setFilteraircon] = useState("unknown aircon");

  const [search, setSearch] = useState("");
  const [between, setBetween] = useState("");
  const [sort, setSort] = useState("");
  const [group, setGroup] = useState("");

  const [pagecount, setPagecount] = useState("");
  const [resultCount, setResultcount] = useState("");

  //table header arrays
  const tableHeaders = [
    { label: "#", value: "" },
    { label: "Date", value: "" },
    { label: "Servicing", value: "" },
    { label: "ApprovedBy", value: "" },
    { label: "Cost", value: "" },
  ];
  //filter arrays
  const statusfilterarr = [
    { status_id: "01", status_name: "pending" },
    { status_id: "02", status_name: "active" },
    { status_id: "03", status_name: "inactive" },
  ];
  const [filterarray, setFilterarray] = useState(statusfilterarr);
  const [clientdata, setClientdata] = useState("");
  const [clientaddress, setClientaddress] = useState("");
  const [clientname, setClientname] = useState("");


  //date range
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: "selection",
  };

  //use effects
  useEffect(() => {
    if (props.aircon_id != null) {
      setFilteraircon(props.aircon_id);
      getallAirconhistory();
    } else {
      setFilteraircon("");
    }
    getallClient();
  }, []);
  useLayoutEffect(() => {
    getallAirconhistory();
    getClient(filterclient);
  }, [page, limit, filter, filterclient, filteraircon, search, between, sort]);

  //get allairconhistory
  const getallAirconhistory = async () => {
    setIsLoaded(true);
    var data = {
      limit: limit,
      page: page,
      filter: filter,
      filterclient: filterclient,
      filteraircon: filteraircon,
      search: search,
      between: between,
      sort: sort,
      group: group,
    };
    return await analyticsService
      .Clientairconhistoryreport(data)
      .then((res) => {
        if (res.data.result) {
          console.log(res.data);
          setIsLoaded(false);
          setAirconhistorys(res.data.result.data);
          setResult(res.data);
          setPage(res.data.result.page);
          setLimit(res.data.result.limit);
          setPagecount(res.data.result.pagecount);
          setResultcount(res.data.result.resultcount);
          const sum = res.data.result.data.reduce((accumulator, object) => {
            return accumulator + Number(object.total_amount);
          }, 0);
          setTotalexpanse(sum);
        } else {
          setIsmessage(res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //pagination
  const paginationfn = (event) => {
    setPage(event.selected + 1);
    console.log(event.selected + 1);
  };
  //search
  const searchfn = (e) => {
    setPage(1);
    setSearch(e.target.value);
  };
  //filter
  const [filterArr, setfilterArr] = useState([]);
  const filterfn = (value) => {
    setPage(1);
    var index = filterArr.indexOf(value);
    if (index > -1) {
      filterArr.splice(index, 1);
      setFilter(filterArr.toString());
    } else {
      filterArr.push(value);
      setFilter(filterArr.toString());
    }
  };
  //sort
  const sortfn = (value) => {
    /*    setSort(value); */
    if (sort === value + " desc") {
      setSort(value + " asc");
      console.log(value + " asc");
    } else if (sort === value + " asc") {
      setSort("");
      console.log(value + "");
    } else {
      setSort(value + " desc");
      console.log(value + " desc");
    }
  };
  
  const betweenfn = async (date) => {
    await setStartDate(date.selection.startDate);
    await setEndDate(date.selection.endDate);
    setBetween(
      format(date.selection.startDate, "yyyy-MM-dd") +
        " , " +
        format(date.selection.endDate, "yyyy-MM-dd")
    );
  };
  const resetbetweenfn = () => {
    setBetween("");
    setStartDate(new Date());
    setEndDate(new Date());
  };
  const resetfilterfn = () => {
    setFilter("");
  };
  //get allclient
  const getallClient = async () => {
    var data = {
      limit: 30,
      page: 1,
      filter: "",
      search: "",
      between: "",
      sort: "client_fullname",
      group: "",
    };
    return await clientService
      .getallClient(data)
      .then((res) => {
        if (res.data.result) {
          setClients(res.data.result.data);
          console.log(res.data);
        } else {
        }
      })
      .catch((err) => {});
  };
  //get client
  const getClient = (value) => {
    clientService
      .getClient(value)
      .then((res) => {
        if (res.data.result) {
          let data = res.data.result.data;
          console.log(res.data.result);
          setClientdata(res.data.result);
        } else {
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
      });
  };
  const selectedcolor = (value) => {
    if (value === "completed") {
      return "badge rounded-pill bg-success";
    } else if (value === "pending") {
      return "badge rounded-pill bg-warning ";
    } else if (value === "approved") {
      return "badge rounded-pill bg-primary";
    } else {
      return "badge rounded-pill bg-dark";
    }
  };
  const pdfrendererelement = () => {
    setGeneratepdf(!generatepdf);
  };
  // Call airconhistory clicks to request another page.
  if (ismessage == "Network Error") {
    return <Alertmsg alertmsg={ismessage} type={false} />;
  }
  /* if (isLoaded == true) {
    return <Loader />
  } */

  return (
    <div className="">
       <div>
          <div className="d-flex  mb-2 ">
            <h1 className="flex-fill">Reports</h1><div>{/* <button
              onClick={() => {
                navigate("/clientevent");
              }}
              type="submit"
              className="btn btn-primary"
            >
              <i className="fa fa-plus"></i> Add Client
            </button> */}</div>
          </div>
          <div className="d-md-flex  mb-2 "></div>
        </div>
      {generatepdf && (
        <>
          <div className="text-end">
            <button
              style={{ position: "absolute", right: 10 }}
              onClick={() => {
                pdfrendererelement();
              }}
              type="submit"
              className="btn  "
            >
              X
            </button>
          </div>
          <Jspdfrender
            pdfarr={airconhistorys}
            total_amount={totalexpanse}
            client_address={clientdata?.client_address}
            client_name={clientdata?.client_fullname}
          />
        </>
      )}
      <div className="text-center">
        {/*  loader and error handler */}
        {isLoaded ? <Loader /> : <></>}
      </div>
      {/*  container */}
      {!generatepdf && (
        <div className="airconhistory-container">
          {/* tebale header part search,filter,sort */}

          <div className="d-md-flex  mb-2 ">
            <div>
              <div className="input-group">
                <select
                  id="client_id"
                  className="form-select"
                  aria-label="client_id"
                  onChange={(e) => {setFilterclient(e.target.value)}}
                >
                  <option value="" disabled>
                    Select Client
                  </option>
                  <option value="">All</option>
                  {clients.map((client, index) => (
                    <option
                      className="text-capitalize"
                      key={index}
                      value={client.client_id}
                    >
                      {client.client_fullname}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* print*/}
            <div className="m-1 ms-auto">
              <button
                onClick={() => {
                  pdfrendererelement();
                }}
                type="submit"
                className="btn btn-dark  w-100"
              >
                Generate pdf
              </button>
            </div>
            {/*  date range  */}
            <div className="m-1">
              <div className="btn-group" role="group">
                {between ? (
                  <button
                    type="button"
                    className="btn bg-white border me-1 "
                    onClick={resetbetweenfn}
                  >
                    <i className="fa fa-times" aria-hidden="true"></i>
                  </button>
                ) : (
                  <></>
                )}
                <button
                  className="btn bg-white border dropdown-toggle"
                  id="dropdownMenuClickableInside"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="outside"
                  aria-expanded="false"
                >
                  <i className="fa fa-calendar" aria-hidden="true"></i>{" "}
                  {between}
                </button>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuClickableInside"
                >
                  <li className="">
                    <DateRangePicker
                      ranges={[selectionRange]}
                      onChange={(date) => betweenfn(date)}
                    />
                  </li>
                  <li className="text-end">
                    <a onClick={resetbetweenfn} className="btn">
                      Reset
                    </a>
                    {/*  <a data-bs-dismiss="dropdown"  className="btn">Okay</a> */}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="table-responsive card bg-white border-0 mb-2">
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  {tableHeaders.map((data, index) => (
                    <th key={index} scope="col">
                      {data.label}
                      {/* table sort */}
                      {data.value != "" ? (
                        <a
                          onClick={() => sortfn(data.value)}
                          className="btn btn-sm"
                        >
                          <span
                            className={
                              sort === data.value + " asc"
                                ? "text-dark"
                                : "text-secondary"
                            }
                          >
                            {" "}
                            <i className="fa fa-long-arrow-up"></i>
                          </span>
                          <span
                            className={
                              sort === data.value + " desc"
                                ? "text-dark"
                                : "text-secondary"
                            }
                          >
                            <i className="fa fa-long-arrow-down"></i>
                          </span>
                        </a>
                      ) : (
                        <></>
                      )}
                    </th>
                  ))}
                  {/* <th scope="col">#</th>
                <th scope="col">aircon name</th>
                <th scope="col">Status</th>
                <th style={{ width: 100 }} scope="col">
                  Action
                </th> */}
                </tr>
              </thead>
              <tbody>
                {/* table data */}
                {airconhistorys ? (
                  <>
                    {airconhistorys.map((data, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td style={{ minWidth: 220 }}>
                          {/*  {data.createdAt} */}
                          {format(new Date(data.createdAt), "dd/MM/yyyy")}
                        </td>
                        <td>
                          <div>
                            <div>{data.aircon_id}</div>
                            {data.service_list}
                          </div>
                        </td>

                        <td>
                          <img
                            style={{ width: 100 }}
                            src={data.approval_signature}
                            alt="signature"
                          />
                        </td>
                        <td style={{ minWidth: 100 }}>$ {data.total_amount}</td>
                      </tr>
                    ))}
                  </>
                ) : (
                  <tr>
                    <td colSpan={10} className="text-center">
                      <div className="text-center p-3">0 data found</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="text-end pb-4 pe-5 fw-bold">
              Total Amount - ${totalexpanse}
            </div>
            <div className="d-none">
              <div className="flex-fill"></div>
              <div className="p-1 "> Items per page </div>
              <div>
                {" "}
                <select
                  value={limit}
                  onChange={(e) => {
                    setLimit(e.target.value);
                    setPage(1);
                  }}
                  className="form-select form-select-sm"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                </select>
              </div>
              <div className="p-1 me-4">
                {page * limit - limit}-{page * limit} of {resultCount}
              </div>
              <ReactPaginate
                previousLabel="< Prev"
                nextLabel="Next >"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                pageCount={pagecount}
                marginPagesDisplayed={3}
                pageRangeDisplayed={3}
                onPageChange={paginationfn}
                containerClassName="pagination"
                activeClassName="actives"
                disabledLinkClassName="text-secondary"
                forcePage={page - 1}
              />
            </div>
          </div>
          <div>
            {airconhistorys ? (
              <>
                {airconhistorys.map((data, index) => (
                  <div
                    className="card shadow-sm border-0 mb-2 d-none"
                    key={index}
                  >
                    <div className="card-body">
                      <div className="card-title mb-0 pb-0 d-flex flex-wrap fw-bolder">
                        <div className="flex-fill">{data.ah_type}</div>
                        <div className="me-2">
                          {data.ah_type === "issue" ? (
                            <>${data.total_amount}</>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div>
                          <span className={selectedcolor(data.ah_status)}>
                            {data.ah_status}
                          </span>
                        </div>
                      </div>
                      <div style={{ fontSize: 12 }}>
                        <span
                          className=" text-secondary  text-capitalize"
                          style={{}}
                        >
                          ID:{data.ah_id}/created:{data.createdBy}/date:
                          {data.createdAt}
                        </span>
                      </div>
                      <div className="textwrapmulti">{data.checked_list}</div>

                      <div className="textwrapmulti">
                        {" "}
                        <span style={{ fontWeight: 500 }}>Remarks:</span>
                        {data.ah_remark}
                      </div>
                      {data.ah_type === "issue" &&
                      data.ah_status !== "completed" ? (
                        <div
                          style={{ background: "#FED5C8" }}
                          className="textwrapmulti border p-1"
                        >
                          <span style={{ fontWeight: 500 }}>
                            Recomentation:
                          </span>
                          {data.service_list}
                        </div>
                      ) : (
                        <></>
                      )}
                      <div className="text-end">
                        {" "}
                        <Link
                          className="btn btn-light me-2"
                          to={"/airconhistoryevent?ah_id=" + data.ah_id}
                        >
                          More
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Reports;
